<script setup lang="ts">
import type { ProgressRootProps } from "reka-ui"
import type { CSSProperties, HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import {
  ProgressIndicator,
  ProgressRoot,
} from "reka-ui"
import { cn } from "@/lib/utils"

const props = withDefaults(
  defineProps<ProgressRootProps & {
    class?: HTMLAttributes["class"]
    indicatorColor?: string
    trackColor?: string
  }>(),
  {
    modelValue: 0,
    indicatorColor: "",
    trackColor: "",
  },
)

const delegatedProps = reactiveOmit(props, "class", "indicatorColor", "trackColor")

const rootStyle = computed<CSSProperties | undefined>(() => {
  if (props.trackColor) return { backgroundColor: props.trackColor }
  if (props.indicatorColor) {
    return { backgroundColor: `color-mix(in srgb, ${props.indicatorColor} 18%, transparent)` }
  }
  return undefined
})

const indicatorStyle = computed<CSSProperties>(() => ({
  backgroundColor: props.indicatorColor || undefined,
  transform: `translateX(-${100 - (props.modelValue ?? 0)}%)`,
}))
</script>

<template>
  <ProgressRoot
    data-slot="progress"
    v-bind="delegatedProps"
    :style="rootStyle"
    :class="
      cn(
        'bg-primary/20 relative h-2 w-full overflow-hidden rounded-full',
        props.class,
      )
    "
  >
    <ProgressIndicator
      data-slot="progress-indicator"
      class="bg-primary h-full w-full flex-1 transition-all"
      :style="indicatorStyle"
    />
  </ProgressRoot>
</template>
